/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { isStrEmptyOrNull } from '../../common/UtilityFunctions';
import Styles from '../../css/LoanDefaultCodes.module.css';
import DateInput from './DateInput';

const ddsOccurrenceDateRow = (label: string, value, name: string, disabled: boolean, onblurfunc = null) => {
  return (
    <tr>
      {!isStrEmptyOrNull(label) && <p className={Styles.ddsoccurrencelabel}>{label}</p>}
      <td className={disabled ? Styles.disabled : Styles.ddsoccurrencedateinput}>
        <DateInput label={label} value={value} name={name} disabled={disabled} onblurfunc={onblurfunc}></DateInput>
      </td>
    </tr>
  );
};

export default ddsOccurrenceDateRow;
